export default __webpack_public_path__ + "static/media/Mobile.155865cd.svg";